module.exports = __webpack_public_path__ + "img/hero.b316cebb.jpg";